import React from 'react'
import { Nav, Tab } from 'react-bootstrap'

import './ContentHeaderNav.scss'

export interface ContentHeaderNavTab {
  label: string
  icon: string | JSX.Element
  onClick: any
  className?: string
  active?: boolean
  disabled?: boolean
  badge?: string | number
}

interface Props {
  tabs: ContentHeaderNavTab[]
}

const ContentHeaderToolbarNav = ({ tabs }: Props) => {

  return (
    <div className="ul-widget__head-nav">
      <Tab.Container>
        <Nav as="ul" className="nav-tabs nav-tabs-line nav-tabs-bold">
          {tabs.map((tab: ContentHeaderNavTab, i: number) => (
            <Nav.Item key={i} as="li">
              <Nav.Link
                className={tab.className || ''}
                active={tab.active}
                disabled={tab.disabled}
                onClick={() => !tab.disabled && tab.onClick()}
              >
                {tab.icon}
                <span className="hide-on-mobile"> {tab.label}</span>
                {tab.badge !== undefined && (
                  <span className="pl4-tab-count">{tab.badge}</span>
                )}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
      </Tab.Container>
    </div>
  )
}

export default ContentHeaderToolbarNav
